import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import defaultBannerImage from "../../assets/images/defaultBannerImage.png";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import defaultTournamentLogo from "../../assets/images/defaultTournamentLogo.png";
import { colors } from "../../values/colors";
import { OverView } from "./OverView";
import {
  AUCTION,
  LEADERBOARD,
  MATCHES,
  OVERVIEW,
  PLAYERS,
  POINTSTABLE,
  SPONSORS,
  TEAMS,
} from "../../values/constants";
import Teams from "./Teams";
import Players from "./Players";
import Matches from "./Matches";
import PointsTable from "./PointsTable";
import {
  getTournamentBanberPic,
  getTournamentProfilePic,
} from "../../uttils/common";
import { useSelector } from "react-redux";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import { useNavigate } from "react-router-dom";

const TournamentDashboard = () => {
  const [tabSelected, setTabSelected] = useState(OVERVIEW);
  const { specificTournamentData } = useSelector((state) => state.tournaments);

  const currentSelectedTab = useSelector(
    (state) => state.home.currentSelectedTab
  );

  const navigate = useNavigate();
  const _selectTab = (ele) => {
    setTabSelected(ele);
  };

  useEffect(() => {
    if (currentSelectedTab !== "Tournaments") {
      navigate(-1);
    }
  }, [currentSelectedTab, navigate]);

  console.log("Specific Tournament Data", specificTournamentData);

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
      }}
    >
      <Stack
        sx={{
          backgroundColor: "black",
          height: "25%",
        }}
      >
        <Stack
          sx={{
            height: "25%",
            width: "100%",
            opacity: 0.5, // Set opacity to make the image lighter
            backgroundImage: `url(${getTournamentBanberPic(
              specificTournamentData?.bannerImage
            )})`,
            backgroundSize: "100% 100%",
            position: "absolute",
          }}
        ></Stack>
        <Stack sx={{ position: "relative" }}>
          <Stack
            mt={2}
            ml={4}
            direction={"row"}
            display={"flex"}
            sx={{ alignItems: "center" }}
          >
            <Typography variant="subtitle1" sx={{ color: colors.white }}>
              Tournaments
            </Typography>

            <NavigateNextIcon
              sx={{ mt: 0.5, fontSize: "28px", color: colors.white }}
            />
            <Typography variant="subtitle1" sx={{ color: colors.accent }}>
              {specificTournamentData?.name}
            </Typography>
          </Stack>

          <Stack
            direction={"row"}
            ml={4}
            mt={1}
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Stack display={"flex"} sx={{ width: "6rem" }}>
              <img
                src={getTournamentProfilePic(specificTournamentData?.logo)}
                style={{ width: "100%", height: "100%" }}
              />
            </Stack>
            <Stack flex={1} sx={{ paddingX: "20px" }}>
              <Stack sx={{ flex: 1 }}>
                <Typography variant="h6" sx={{ color: colors.white }}>
                  {specificTournamentData?.name}
                </Typography>

                {specificTournamentData?.groundId?.name && (
                  <Typography
                    sx={{ fontWeight: 400, color: colors.white }}
                    variant="subtitle1"
                  >
                    {specificTournamentData?.groundId?.name}
                  </Typography>
                )}

                {specificTournamentData?.city?.name && (
                  <Stack
                    display={"flex"}
                    flexDirection={"row"}
                    sx={{
                      alignItems: "center",

                      mt: 1,
                    }}
                  >
                    <Stack sx={{ mr: 0.5 }}>
                      <PlaceOutlinedIcon
                        sx={{ fontSize: "1rem", color: colors.white }}
                      />
                    </Stack>
                    <Stack>
                      <Typography
                        sx={{ fontWeight: 400, color: colors.white }}
                        variant="subtitle1"
                      >
                        {specificTournamentData?.city?.name}
                      </Typography>
                    </Stack>
                  </Stack>
                )}
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        display={"flex"}
        overflow={"scroll"}
        spacing={2}
        py={2}
        px={4}
        direction={"row"}
        sx={{
          boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.2)",
          width: "100%",
        }}
      >
        <Button
          sx={{
            flex: 1,
            minWidth: "7rem",
            paddingY: "0.6rem",
            textTransform: "initial",
          }}
          className={tabSelected == OVERVIEW ? "selectedTab" : "unSelectedTab"}
          onClick={() => _selectTab(OVERVIEW)}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "1rem",
              color: tabSelected == OVERVIEW ? "#fff" : "#000",
            }}
          >
            OverView
          </Typography>
        </Button>
        <Button
          sx={{
            flex: 1,
            minWidth: "7rem",
            paddingY: "0.6rem",
            textTransform: "initial",
          }}
          className={tabSelected == AUCTION ? "selectedTab" : "unSelectedTab"}
          onClick={() => _selectTab(AUCTION)}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "1rem",
              color: tabSelected == AUCTION ? "#fff" : "#000",
            }}
          >
            Auction
          </Typography>
        </Button>
        <Button
          sx={{
            flex: 1,
            minWidth: "7rem",
            paddingY: "0.6rem",
            textTransform: "initial",
          }}
          className={tabSelected == TEAMS ? "selectedTab" : "unSelectedTab"}
          onClick={() => _selectTab(TEAMS)}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "1rem",
              color: tabSelected == TEAMS ? "#fff" : "#000",
            }}
          >
            Teams
          </Typography>
        </Button>
        <Button
          sx={{
            flex: 1,
            minWidth: "7rem",
            paddingY: "0.6rem",
            textTransform: "initial",
          }}
          className={tabSelected == PLAYERS ? "selectedTab" : "unSelectedTab"}
          onClick={() => _selectTab(PLAYERS)}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "1rem",
              color: tabSelected == PLAYERS ? "#fff" : "#000",
            }}
          >
            Players
          </Typography>
        </Button>
        <Button
          sx={{
            flex: 1,
            minWidth: "7rem",
            paddingY: "0.6rem",
            textTransform: "initial",
          }}
          className={tabSelected == MATCHES ? "selectedTab" : "unSelectedTab"}
          onClick={() => _selectTab(MATCHES)}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "1rem",
              color: tabSelected == MATCHES ? "#fff" : "#000",
            }}
          >
            Matches
          </Typography>
        </Button>
        <Button
          sx={{
            flex: 1,
            minWidth: "7rem",
            paddingY: "0.6rem",
            textTransform: "initial",
          }}
          className={
            tabSelected == POINTSTABLE ? "selectedTab" : "unSelectedTab"
          }
          onClick={() => _selectTab(POINTSTABLE)}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "1rem",
              color: tabSelected == POINTSTABLE ? "#fff" : "#000",
            }}
          >
            Points Table
          </Typography>
        </Button>
        <Button
          sx={{
            flex: 1,
            minWidth: "7rem",
            paddingY: "0.6rem",
            textTransform: "initial",
          }}
          className={
            tabSelected == LEADERBOARD ? "selectedTab" : "unSelectedTab"
          }
          onClick={() => _selectTab(LEADERBOARD)}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "1rem",
              color: tabSelected == LEADERBOARD ? "#fff" : "#000",
            }}
          >
            LeaderBoard
          </Typography>
        </Button>
        <Button
          sx={{
            flex: 1,
            minWidth: "7rem",
            paddingY: "0.6rem",
            textTransform: "initial",
          }}
          className={tabSelected == SPONSORS ? "selectedTab" : "unSelectedTab"}
          onClick={() => _selectTab(SPONSORS)}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "1rem",
              color: tabSelected == SPONSORS ? "#fff" : "#000",
            }}
          >
            Sponsors
          </Typography>
        </Button>
      </Stack>
      {/* </Stack> */}
      {tabSelected == POINTSTABLE && <PointsTable />}
      <Stack p={2}>
        {tabSelected == OVERVIEW && <OverView item={specificTournamentData} />}
        {tabSelected == TEAMS && (
          <Teams teams={specificTournamentData?.teams} />
        )}
        {tabSelected == PLAYERS && <Players item={specificTournamentData} />}
        {tabSelected == MATCHES && <Matches item={specificTournamentData} />}
      </Stack>
    </Box>
  );
};

export default TournamentDashboard;
